export const EXERCISE_DATA_STYLE_DEFAULT = 'SingleData'

export const EXERCISE_DATA_STYLE_OPTIONS = [
  { label: 'Single data', value: EXERCISE_DATA_STYLE_DEFAULT },
  { label: 'Combination data', value: 'CombinationData' },
  { label: 'Location data', value: 'LocationData' },
] as const
